import { Networks } from "./blockchain";

const POLYGON_TEST = {
    FLIP_ADDRESS: "0x00Ef7626C7BC7aB28d25A1DA9D55e2F64853F1c5",
};

export const getAddresses = (networkID: number) => {
    if (networkID === Networks.POLYGON_TEST) return POLYGON_TEST;

    throw Error("Network don't support");
};
